import { Helmet } from "react-helmet-async";

export const SITE_URL = process.env.REACT_APP_SITE_URL || window.location.origin;

export default function Seo({ title, description, path = "/", type = "website", image, jsonLd }) {
  const url = SITE_URL + path;
  const img = image
    ? image.startsWith("http")
      ? image
      : SITE_URL + image
    : `${SITE_URL}/assets/og-image.jpg`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="CV. Sinar Al Mubarokah" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
